<mat-toolbar color="primary">
  <nav class="w-100">
    <div id="dish-logo-container">
      <img
        src="/assets/images/Dish_Logo-white.png"
        alt="AVI Dish Logo"
        id="dish-logo"
        />
    </div>
    <button mat-button disableRipple (click)="navigateTo('/admin', false)">Home</button>

    @for (menu of menus; track menu; let i = $index) {
      <dish-mat-menu-button
        [menuClosed]="menuClosed$"
        (click)="openMenu(i)"
        [matMenuTriggerFor]=""
        aria-haspopup="true"
        [menuName]="menu.name"
        >
        {{ menu.name }}
      </dish-mat-menu-button>
      <mat-menu (close)="menuClosed(menu.name)" #menu>
        @for (link of menu.links; track link) {
          <button class="menu-link" mat-menu-item
          (click)="navigateTo(link.href, link.routerLink)">{{ link.label }}</button>
        }
      </mat-menu>
    }

    <button mat-button disableRipple (click)="navigateTo('/admin/import-errors', false)">Import</button>
    <button mat-button disableRipple (click)="navigateTo('/Admin/ManageUsers', false)">Users</button>
    <button mat-button disableRipple (click)="navigateTo('/Admin/Help', false)">Help</button>
    <dish-auth-header-buttons
      [currentUrl]="currentUrl"
      (userLoggedOut)="logout()"
    ></dish-auth-header-buttons>
  </nav>
</mat-toolbar>
